import { render } from "./TagDetailView.vue?vue&type=template&id=a5121032"
import script from "./TagDetailView.vue?vue&type=script&lang=js"
export * from "./TagDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__